import { render, staticRenderFns } from "./OrderReturnConfirmationPage.vue?vue&type=template&id=fdf72bf0"
import script from "./OrderReturnConfirmationPage.vue?vue&type=script&lang=js"
export * from "./OrderReturnConfirmationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports